import React, { useState } from 'react';

const LoginScreen = ({ onLogin }) => {
  const [pin, setPin] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  // You can change this PIN - keep it secret!
  const CORRECT_PIN = '8090'; // Change this to your desired PIN

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    // Simulate network delay for security
    setTimeout(() => {
      if (pin === CORRECT_PIN) {
        localStorage.setItem('eynvision_auth', 'true');
        onLogin();
      } else {
        setError('Incorrect PIN. Access denied.');
        setPin('');
      }
      setLoading(false);
    }, 1000);
  };

  const handlePinChange = (e) => {
    const value = e.target.value.replace(/\D/g, ''); // Only numbers
    if (value.length <= 6) {
      setPin(value);
      setError('');
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, var(--primary-bg) 0%, var(--secondary-bg) 50%, var(--primary-bg) 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '1rem'
    }}>
      <div className="card" style={{
        maxWidth: '400px',
        width: '100%',
        textAlign: 'center',
        background: 'var(--card-bg)',
        border: '2px solid var(--accent-yellow)',
        boxShadow: 'var(--glow)'
      }}>
        {/* Eynvision Logo/Header */}
        <div style={{ marginBottom: '2rem' }}>
          <h1 className="text-3xl font-bold mb-2" style={{
            background: 'linear-gradient(135deg, var(--accent-yellow) 0%, #ffff66 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            textShadow: '0 0 30px rgba(255, 255, 0, 0.5)'
          }}>
            ⚡ Eynvision
          </h1>
          <h2 className="text-xl text-yellow mb-4">Expense Tracker</h2>
          <p className="text-gray">Enter PIN to access your startup dashboard</p>
        </div>

        {/* PIN Form */}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Access PIN</label>
            <input
              type="password"
              value={pin}
              onChange={handlePinChange}
              className="form-input"
              placeholder="Enter 4-6 digit PIN"
              style={{
                textAlign: 'center',
                fontSize: '1.5rem',
                letterSpacing: '0.5rem',
                fontFamily: 'monospace'
              }}
              maxLength="6"
              required
            />
          </div>

          {error && (
            <div className="error-message">
              🚫 {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading || pin.length < 4}
            className="btn btn-primary"
            style={{ width: '100%', fontSize: '1.1rem' }}
          >
            {loading ? (
              <>
                <div className="spinner"></div>
                Verifying...
              </>
            ) : (
              <>
                🔓 Access Dashboard
              </>
            )}
          </button>
        </form>

        {/* Info */}
        <div style={{
          marginTop: '2rem',
          padding: '1rem',
          background: 'var(--secondary-bg)',
          borderRadius: '8px',
          border: '1px solid var(--border)'
        }}>
          <p className="text-sm text-muted">
            🔒 Secure access for Eynvision partners only
          </p>
          <p className="text-xs text-muted mt-2">
            Husnain • Haroon • Hashim
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginScreen; 